<template>
  <div></div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export default class LogoutView extends Vue {
  async mounted(): Promise<void> {
    await this.$store.direct.dispatch.user.logout();
  }
}
</script>

<style scoped></style>
